import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Guide from "../pages/guide/page";
import ArticlePage from "../pages/article/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/oopbuy-spreadsheet-guide", element: <Guide /> },
  { path: "/oopbuy-spreadsheet-sicherheit", element: <ArticlePage /> },
  { path: "/oopbuy-spreadsheet-vergleich", element: <ArticlePage /> },
  { path: "/oopbuy-spreadsheet-anleitung", element: <ArticlePage /> },
  { path: "/oopbuy-spreadsheet-kosten", element: <ArticlePage /> },
  { path: "/oopbuy-spreadsheet-erfahrungen", element: <ArticlePage /> },
  { path: "/oopbuy-sneaker-guide", element: <ArticlePage /> },
  { path: "/oopbuy-streetwear-guide", element: <ArticlePage /> },
  { path: "/oopbuy-accessoires-guide", element: <ArticlePage /> },
  { path: "/oopbuy-spreadsheet-tipps", element: <ArticlePage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;